/**
 * Custom Header — alleen gedrag dat niet in Liquid kan.
 * Search bar en CTA-knoppen worden nu via Liquid in de header gerenderd (snippets + header/header-row/header-actions).
 */

const ensureCartCount = () => {
  const count = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
  if (!count) return;

  const ensure = () => {
    if (!count.textContent.trim()) {
      count.textContent = '0';
    }
  };

  ensure();
  new MutationObserver(ensure).observe(count, { childList: true, characterData: true, subtree: true });
};

const init = () => {
  ensureCartCount();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
